<template lang="pug">
  .component-tabbed-vehicle-reports
    .action-bar
      .title
        h2 Maintenance Requests
      .action

    .tabs-inner-content

      MaintenanceRequestList(:filters="search", listing-type="detail-listing" )
      //base-list(:component="component", :dataLoader="dataLoader", componentType="vehicle-list" ref="list")
      //paginated-list(:itemComponent="component", :data="items", :type="'vehicle-list'", :perPage="resultsPerpage", @changePage="loadReportings")
</template>
<script type="text/babel">
import KeplerBackofficeSdk from "src/lib/kepler/backoffice";
import ReportingListForm from "../../structure/ui/filters/ReportingListForm";
import BaseList from "../../../pages/backoffice/BaseList";
import DateRangePicker from "../../structure/DateRangePicker";
import MaintenanceRequestList from "../../../pages/backoffice/MaintenanceRequestList.vue";
import ActionBar from "../../structure/ui/ActionBar.vue";
import Dropdown from "../../structure/foundation/Dropdown.vue";

export default {
  name: "TabbedVehicleInterventionRequests",
  components: {
    Dropdown,
    ActionBar,
    MaintenanceRequestList,
    DateRangePicker,
    BaseList,
    ReportingListForm,
  },
  data() {
    return {
      component: require('components/backoffice/Reservation.vue'),
      search: {
        start: '',
        end: '',
        vehicle_id: this.$route.params.id,
      },

    }
  },
  created() {
  },

  methods: {
    dataLoader(callback, page, resultsPerPage) {

      KeplerBackofficeSdk.vehicles.list(page, resultsPerPage,this.search).movements((data) => {
        callback(data)
      })
    },
    dateRangeSelected(range) {
      if( range.start == "" && range.end == "") {
        this.filterReservation()
      }
      this.search.start = range.start
      this.search.end = range.end
    },
    filterReservation() {
      this.$refs.list.debouncedLoader()
    },
  },

}
</script>
<style lang="sass" rel="stylesheet/sass">

</style>



// WEBPACK FOOTER //
// VehicleInterventionRequests.vue?8281fbd8